export default {
  token: (state) => state.token,
  user: (state) => state.token && 'user' in state.token ? state.token.user : {},
  username: (state) => state.token && 'user' in state.token ? state.token.user.name : null,
  lines: (state) => state.token && 'user' in state.token ? state.token.user.lines : null,
  role_id: state => state.role_id,
  is_admin: state => state.is_admin,
  plants: state => state.plants,
  user: state => state.user,
  password: state => state.password,
  mini: state => state.mini,
  sub_menu: state=> state.sub_menu,
  sub_menu_dashboard: state=> state.sub_menu_dashboard,
  client: state=> state.client,
  password_expires:state=>state.password_expires,
  has_dashboards:state => state.has_dashboards
};
